import { useState, useEffect } from "react";

const STATES = [
  { label: "Normaal", temp: 34, color: "#2B9FD7", pct: 28 },
  { label: "Vooralarm", temp: 68, color: "#FF8A00", pct: 62 },
  { label: "Alarm", temp: 96, color: "#E5483F", pct: 92 },
];

export const TempGauge = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % STATES.length), 2800);
    return () => clearInterval(t);
  }, []);

  const state = STATES[idx];

  return (
    <div
      className="flex items-center gap-5 rounded-2xl border border-white/10 bg-[#090D10]/70 p-5 backdrop-blur-md"
      data-testid="temp-gauge"
      aria-label={`Temperatuurindicator: ${state.label}`}
    >
      <div className="relative h-28 w-3 overflow-hidden rounded-full bg-white/10">
        <div
          className="absolute bottom-0 w-full rounded-full transition-[height,background-color] duration-1000 ease-out"
          style={{ height: `${state.pct}%`, backgroundColor: state.color }}
        />
      </div>
      <div>
        <p
          className="font-heading text-3xl font-bold tabular-nums transition-colors duration-1000"
          style={{ color: state.color }}
        >
          {state.temp}°C
        </p>
        <span
          className="mt-2 inline-block rounded-full border px-3 py-1 font-heading text-[11px] font-semibold uppercase tracking-[0.2em] transition-colors duration-1000"
          style={{ color: state.color, borderColor: `${state.color}66` }}
        >
          {state.label}
        </span>
        <p className="mt-2 text-[10px] text-[#CBD3D9]/50">Gesimuleerde waarden</p>
      </div>
    </div>
  );
};
